import React, { useCallback } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import '../styles/ModalComponent.css';
import { bool, func, node, string } from 'prop-types';

const ModalComponentNoButton = ({ modalTitle, children, handleSave = () => { }, show, setShow = () => {}, showConfirmButton = true, size = undefined, contentClassName = undefined }) => {
    const handleClose = useCallback(() => setShow(false), [setShow]);
    const onHandleSave = useCallback(() => {
        handleSave();
        setShow(false);
    }, [handleSave, setShow]);
    return (
        <Modal
            size={size}
            contentClassName={contentClassName}
            style={{ zIndex: '10000' }}
            show={show}
            onHide={handleClose}>
            <Modal.Header
                closeButton>
                <Modal.Title>{modalTitle}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{children}</Modal.Body>
            <Modal.Footer>
                <Button
                    variant={'secondary'}
                    onClick={handleClose}>
                Close
                </Button>
                {showConfirmButton && <Button
                    variant={'primary'}
                    onClick={onHandleSave}>
                    Confirm
                </Button>}
            </Modal.Footer>
        </Modal>
    );
};

ModalComponentNoButton.propTypes = {
    modalTitle: string,
    children: node,
    handleSave: func,
    show: bool,
    setShow: func,
    showConfirmButton: bool,
    size: string,
    contentClassName: string,
};

export default ModalComponentNoButton;